export const VALID_ENVIRONMENT_NAME = '[a-zA-Z0-9 \\-_]+';
export const VALID_VARIABLE_KEY = '\\$[a-zA-Z]{1}[a-zA-Z0-9_]*';
export const VALID_OUTPUT_VARIABLE_KEY = '^[a-zA-Z]{1}[a-zA-Z0-9_]*';
export const DEFAULT_ENVIRONMENTS = [['test'], ['staging'], ['production']];
export const DEFAULT_MEMORY_LIMIT = 1024;
export const DEFAULT_BUILD_CONTAINER_MEMORY_LIMIT = 4 * DEFAULT_MEMORY_LIMIT;
export const MAX_STEPS = 100;
export const DEFAULT_MAX_STEP_SIZE_FOR_CLOUD_RUNNERS = 2;
export const DEFAULT_MAX_STEP_SIZE_FOR_SELF_HOSTED_RUNNERS = 16;
export const DEFINITION_SHAPE_DESCRIPTION = 'definition section';
